<template>
  <v-row v-if="!isLoading">

    <!-- Stats: desktop normal, mobile collapsible -->
    <v-col cols="12">
      <!-- Desktop: always show -->
      <div class="d-none d-md-block">
        <dashboard-statistics-card :all-counts="allCounts"></dashboard-statistics-card>
      </div>

      <!-- Mobile: toggle button + expandable -->
      <div class="d-md-none">
        <div class="stats-toggle-btn" @click="statsOpen = !statsOpen">
          <v-icon size="20" color="white" class="mr-2">mdi-chart-bar</v-icon>
          <span>Statistika</span>
          <v-icon
            size="20"
            color="white"
            class="ml-auto"
            :style="{ transform: statsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }"
          >mdi-chevron-down</v-icon>
        </div>
        <v-expand-transition>
          <div v-show="statsOpen" class="stats-accordion-content">
            <dashboard-statistics-card :all-counts="allCounts"></dashboard-statistics-card>
          </div>
        </v-expand-transition>
      </div>
    </v-col>

    <!-- Map — always below stats -->
    <v-col cols="12" sm="12" md="12">
      <dashboard-card-live-tracking></dashboard-card-live-tracking>
    </v-col>

    <!-- Nen harte: ora kur mbyllen vetvetiu udhetimet e harruara. -->
    <v-col cols="12">
      <dashboard-card-auto-start></dashboard-card-auto-start>
      <dashboard-card-auto-stop></dashboard-card-auto-stop>
    </v-col>

    <!--    <v-col cols="12" sm="12" md="6">-->
    <!--      <dashboard-weekly-overview-->
    <!--        v-if="mode === 'advanced'"-->
    <!--        :trip-count="plannedTripsCount"-->
    <!--        :trip-dates="plannedTripsDates"-->
    <!--      ></dashboard-weekly-overview>-->
    <!--    </v-col>-->
    <!--    <v-col cols="12" md="6">-->
    <!--      <dashboard-card-sales-by-trips-->
    <!--        v-if="mode === 'advanced'"-->
    <!--        :best-trips="bestTrips"-->
    <!--      ></dashboard-card-sales-by-trips>-->
    <!--    </v-col>-->
  </v-row>
  <v-row v-else>
    <!--    <v-col cols="12" sm="6" md="6">-->
    <!--      <v-skeleton-loader type="card" height="200"></v-skeleton-loader>-->
    <!--    </v-col>-->
    <!--    <v-col cols="12" md="6">-->
    <!--      <v-row class="match-height">-->
    <!--        <v-col cols="12" sm="6">-->
    <!--          <v-skeleton-loader type="card" height="200"></v-skeleton-loader>-->
    <!--        </v-col>-->
    <!--        <v-col cols="12" sm="6">-->
    <!--          <v-skeleton-loader type="card" height="200"></v-skeleton-loader>-->
    <!--        </v-col>-->
    <!--      </v-row>-->
    <!--    </v-col>-->

    <v-col cols="12" md="12">
      <v-skeleton-loader type="card" height="120"></v-skeleton-loader>
    </v-col>

    <v-col cols="12" sm="6" md="6">
      <v-skeleton-loader type="image" height="500"></v-skeleton-loader>
    </v-col>

    <v-col cols="12" md="6">
      <v-skeleton-loader type="image" height="500"></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiCurrencyUsd, mdiCloseOctagonOutline } from '@mdi/js';
import { mesazhiIGabimit } from '@/utils/error-message';
import StatisticsCardVertical from '@/components/statistics-card/StatisticsCardVertical.vue';

import auth from '@/services/AuthService';
// demos
import DashboardStatisticsCard from './DashboardStatisticsCard.vue';
import DashboardCardRemainingCoins from './DashboardCardRemainingCoins.vue';
import DashboardCardSalesByTrips from './DashboardCardSalesByTrips.vue';
import DashboardWeeklyOverview from './DashboardWeeklyOverview.vue';
import DashboardCardRides from './DashboardCardRides.vue';
import DashboardCardLiveTracking from '@/views/dashboard/DashboardCardLiveTracking.vue';
import DashboardCardAutoStop from '@/views/dashboard/DashboardCardAutoStop.vue';
import DashboardCardAutoStart from '@/views/dashboard/DashboardCardAutoStart.vue';

export default {
  components: {
    DashboardCardLiveTracking,
    DashboardCardAutoStop,
    DashboardCardAutoStart,
    StatisticsCardVertical,
    DashboardStatisticsCard,
    DashboardCardRemainingCoins,
    DashboardCardSalesByTrips,
    DashboardWeeklyOverview,
    DashboardCardRides,
  },
  data() {
    return {
      mode: null,
      isLoading: false,
      statsOpen: false,
      consumedCoins: {
        statTitle: 'Consumed Coins',
        icon: mdiCloseOctagonOutline,
        color: 'error',
        amount: '',
      },
      bestTrips: [],
      plannedTripsCount: [],
      plannedTripsDates: [],
      bestTripsColors: ['success', 'error', 'warning', 'secondary', 'error'],
      purchasedCoins: {
        statTitle: 'Purchased Coins',
        icon: mdiCurrencyUsd,
        color: 'success',
        amount: '',
      },
      remainingCoins: null,
      allCounts: [
        {
          title: 'Students',
          total: '',
        },
        {
          title: 'Guardians',
          total: '',
        },
        {
          title: 'Drivers',
          total: '',
        },
        // {
        //   title: 'Routes',
        //   total: '',
        // },
        // {
        //   title: 'Stops',
        //   total: '',
        // },
        // {
        //   title: 'Trips',
        //   total: '',
        // },
        {
          title: 'Schools',
          total: '',
        },
        {
          title: 'Buses',
          total: '',
        },
        {
          title: 'Classes',
          total: '',
        },
      ],
      studentRides: [],
    };
  },
  mounted() {
    this.mode = auth.getMode();
    this.fetchDashboardStatistics();
    this.getStudentRides();
  },
  methods: {
    getTripColor(trip) {
      if (trip.is_morning == 1) {
        return 'success';
      } else {
        return 'info';
      }
    },
    fetchDashboardStatistics() {
      this.isLoading = true;
      this.reservations = [];
      axios
        .get(`/school-dashboard/all`)
        .then((response) => {
          // this.purchasedCoins.amount = response.data?.purchasedCoins;
          // this.consumedCoins.amount = response.data?.consumedCoins;
          // this.remainingCoins = response.data?.remainingCoins;
          this.allCounts[0].total = response.data?.totalStudents;
          this.allCounts[1].total = response.data?.totalGuardians;
          this.allCounts[2].total = response.data?.totalDrivers;
          this.allCounts[3].total = response.data?.totalSchools;
          this.allCounts[4].total = response.data?.totalBuses;
          this.allCounts[5].total = response.data?.totalClasses;
          // this.allCounts[3].total = response.data?.totalRoutes;
          // this.allCounts[4].total = response.data?.totalStops;
          // this.allCounts[5].total = response.data?.totalTrips;
          this.bestTrips = response.data?.bestTrips;
          //merge bestTrips with bestTripsColors
          // this.bestTrips.forEach((item, index) => {
          //   item.color = this.bestTripsColors[index];
          // });
          // for (var key in response.data?.plannedTrips ?? []) {
          //   this.plannedTripsCount.push(response.data?.plannedTrips?.[key]);
          //   this.plannedTripsDates.push(key);
          // }
          // this.plannedTripsCount.push(1);
          // this.plannedTripsDates.push(1);
          // this.plannedTripsCount.push(2);
          // this.plannedTripsDates.push(2);
          // this.plannedTripsCount.push(3);
          // this.plannedTripsDates.push(3);
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });

          auth.checkError(
            error.response.data.message,
            this.$router,
            this.$swal
          );
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getStudentRides() {
      axios
        .get(`/school-dashboard/student-rides`)
        .then((response) => {
          this.studentRides = response?.data;
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });

          auth.checkError(
            error.response.data.message,
            this.$router,
            this.$swal
          );
        });
    },
  },
};
</script>

<style lang="scss">
.v-skeleton-loader__image {
  height: 400px !important;
}

.stats-accordion {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.stats-accordion-content {
  width: 100%;
  padding-bottom: 6px;
}

/* Hide the card's own "Statistika" header inside the mobile accordion */
.stats-accordion-content .modern-stats-header {
  display: none !important;
}
.stats-accordion-content .modern-stats-card {
  border-radius: 0 0 14px 14px !important;
}

.stats-toggle-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #e65100, #f57c00);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 11px 16px;
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 3px 10px rgba(230,81,0,0.25);
  letter-spacing: 0.3px;
}
</style>
